<template>
  <v-container pa-0 pt-1>
    <div v-if="debug">
      <code>{{ items }}</code>
    </div>
    <v-card outlined>
      <v-data-table :items="items" :headers="headers">
        <template v-slot:item.pricing.totalBuy="{ item }">
          {{ item.pricing.totalBuy | priceLabeler }}
        </template>
        <template v-slot:item.supplierCommission="{ item }">
          {{ item.supplierCommission | priceLabeler }}
        </template>
        <template v-slot:item.balance="{ item }">
          {{ item.balance | priceLabeler }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon small @click="onShowReceipts(item)">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon color="green" small v-on="on">mdi-currency-usd </v-icon>
              </template>
              <span>Receipts</span>
            </v-tooltip>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-container>
      <v-row>
        <v-col>
          <h6 class="caption text-center">SUPPLIER TOTAL COMMISSION</h6>
          <h5 class="text-center" style="font-size: 1.8vw">
            {{ totalSupplierCommission.toFixed(2) | priceLabeler }}
          </h5>
        </v-col>
      </v-row>
    </v-container>
    <supplier-commission-receipts-dialog
      :show="showReceiptsDialog"
      @close="showReceiptsDialog = false"
      v-model="selectedItem"
    />
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { getTotal, removeGQLTypename } from "../../../helpers";
import SupplierCommissionReceiptsDialog from "../finances/supplier-commission-receipts/SupplierCommissionReceiptsDialog.vue";
const UPDATE_IT_HEADER = gql`
  mutation updateItineraryHeader($id: ID!, $input: ItineraryHeaderInput!) {
    updateItineraryHeaderInfo(id: $id, itineraryHeaderInput: $input) {
      id
      profit {
        commission
        commissionAdjustment
      }
    }
  }
`;
export default {
  name: "itinerary-supplier-commission",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    SupplierCommissionReceiptsDialog,
  },

  data() {
    return {
      debug: false,
      adjustment: this.value ? this.value.profit.commissionAdjustment : 0,
      showReceiptsDialog: false,
      selectedItem: null,
      headers: [
        { text: "Supplier", value: "supplierName" },
        { text: "Service", value: "serviceName" },
        { text: "Cost Price", value: "pricing.totalBuy" },
        { text: "Currency", value: "pricing.currencyBuy" },
        {
          text: "Commission %",
          value: "supplierCommission",
        },
        {
          text: "Commission",
          value: "supplierCommissionAmount",
        },
        {
          text: "Balance",
          value: "balance",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    commission() {
      return this.value ? Number(this.value.profit.commission) : 0;
    },
    netCommission() {
      return this.commission + Number(this.adjustment);
    },
    totalSupplierCommission() {
      return getTotal(this.items, (item) => item.supplierCommissionAmount);
    },
    items() {
      return this.value && this.value.items
        ? this.value.items.edges.map(removeGQLTypename).map((item) => {
            const paid = getTotal(item.supplierCommissionReceipts, (scr) =>
              Number(scr.amount)
            );
            const supplierCommissionAmount = item.pricing
              ? (
                  (Number(item.pricing.totalBuy) *
                    Number(item.supplierCommission)) /
                  100
                ).toFixed(2)
              : 0;
            return {
              ...item,
              supplierCommissionAmount,
              balance: supplierCommissionAmount - paid,
            };
          })
        : [];
    },
  },

  methods: {
    onShowReceipts(item) {
      //console.log("showing receipts list for: ", item);
      this.selectedItem = { ...item };
      this.showReceiptsDialog = true;
    },
    onSave() {
      this.$apollo
        .mutate({
          mutation: UPDATE_IT_HEADER,
          variables: {
            id: this.value.id,
            input: {
              commissionAdjustment: Number(this.adjustment),
            },
          },
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItinerarySupplierCommission.vue